import clsx from 'clsx';
import IconButton from 'components/IconButton/IconButton';
import { motion } from 'framer-motion';
import { observer } from 'mobx-react-lite';
import { useCartContext } from '../CartProvider';

const ExpandOptionsButton = observer(
  ({
    expand,
    onExpand,
  }: {
    expand: boolean;
    onExpand: () => void;
    expandHeight: number;
  }) => {
    const { itemsByLocation, activeLocation } = useCartContext();
    const addedOptionsCount = itemsByLocation(activeLocation?.id).filter(
      (item) => item.item_details?.isOtherOption,
    ).length;
    return (
      <motion.div
        initial={{ scaleY: 0, opacity: 0, y: 50 }}
        animate={{ scaleY: 1, opacity: 1, y: 0 }}
        exit={{ scaleY: 0, opacity: 0, y: 50 }}
        transition={{ duration: 0.4, ease: 'easeInOut' }}
        className="relative w-full"
      >
        <div
          className={clsx(
            'flex h-[88px] w-full items-center justify-between gap-4 rounded-b-sm border border-[#47556980] p-4',
            !expand && 'border-t-0',
            expand && 'rounded-t-[4px]',
          )}
        >
          <p
            className="flex w-full cursor-pointer items-center justify-between gap-2 font-bold"
            onClick={onExpand}
          >
            <span className="text-content-base-subdued">All other options</span>
            <div className="flex gap-4">
              {!expand && addedOptionsCount > 0 && (
                <span className="text-base font-bold text-[#9796F3]">
                  ({addedOptionsCount}) other option added to cart!
                </span>
              )}
              <IconButton
                icon={'chevronDown'}
                className={clsx({ 'rotate-180': !expand })}
                buttonType="ghost"
                color="currentColor"
              />
            </div>
          </p>
        </div>
      </motion.div>
    );
  },
);

export default ExpandOptionsButton;
